/* ================================================== */
/* ANGULARJS > Modules
/* ================================================== */

var app = angular.module('app', ['ngSanitize','ngRoute','afkl.lazyImage']).config(['$interpolateProvider', function($interpolateProvider) {
	$interpolateProvider.startSymbol('{(').endSymbol(')}');
}]);